module.exports = __webpack_public_path__ + "img/swiper-4.2f5c146.png";